import type { FeatureConfigMap } from '@luna/feature-config';

import type { PensionFeatureConfig } from '../types/PensionFeatureConfig';
import { pension as base } from './base';
import { pension as AT } from './AT';
import { pension as CZ } from './CZ';
import { pension as HR } from './HR';
import { pension as HU } from './HU';
import { pension as RO } from './RO';
import { pension as RS } from './RS';
import { pension as SK } from './SK';

export const featureConfigMap: FeatureConfigMap<PensionFeatureConfig> = {
    base,
    AT: AT as PensionFeatureConfig,
    CZ: CZ as PensionFeatureConfig,
    HR: HR as PensionFeatureConfig,
    HU: HU as PensionFeatureConfig,
    RO: RO as PensionFeatureConfig,
    RS: RS as PensionFeatureConfig,
    SK: SK as PensionFeatureConfig,
};
